
  <ngx-loading [show]="pageload"></ngx-loading>
<div >
  <!-- <div style="margin-top:1%; margin-bottom:-5px; margin-left:10px">
    <h6>
      <span style="padding-right:5px"></span>
      <i class="fa fa-file-text-o"></i>
      <b>Permit Type </b> <span style="color:lightgray">* Please select a permit type and click 'Start' to start the application process</span>
    </h6>
  </div> -->

</div>
<br>

<div class="col-md-12">
  <div class="row">
      <div class="col-sm-6">
          <!-- <h6>
              <span style="padding-right:5px"></span>
              <b>Types & Rates</b>
            </h6>
            <div class="list-group">
                <a *ngFor="let item of permittype, let i=index" href="javascript:void(0);" class="list-group-item-light list-group-item-action flex-column align-items-start" (click)="onSelectType(i,item)">
                  <div class="d-flex w-100 justify-content-between">
                    <h5 class="mb-1">{{item.code}}</h5>
                    <small>{{item.fee}}</small>
                  </div>
                  <p class="mb-1">{{item.description}}</p>
                  <i *ngIf="selectedIndex === i" class="fa fa-check-circle-o" style="font-size:2em !important; float:right; color:green"></i>
                </a>
              </div> -->


              <br>
              <div class="form-group">
                  <!-- <h4>Passanger or Freights</h4> -->
                  <div class="pull-left top-margin">
                    <div class="icon-left">
                       <img src="assets/passenger.png"/>
                    </div>
                    <div class="radio">
                       <input type="radio" name="vehicle-type" value="2" ([ngModel])="vehicleType" [checked]="vehicleType=='2'" (click)="selectVehicleType('2')" /> Passenger
                    </div>
                  </div>
                  <div class="pull-left top-margin">
                    <div class="icon-right">
                       <img src="assets/Freight.png"/>
                    </div>
                    <div class="radio">
                       <input type="radio" name="vehicle-type" value="1" ([ngModel])="vehicleType" [checked]="vehicleType=='1'" (click)="selectVehicleType('1')" /> Freight
                    </div>
                  </div>

             </div>
             <br style="clear:both;">
             <div class="form-group">
              <!-- <h4>Temperary or Long-term Permit</h4> -->
              <hr>
              <div class="pull-left ml-3">
              <div class="icon-left pl-3" style="height:auto">
                <img src="assets/Temporarypermit.png" style="height:118px;width:118px;">
              </div>
              <div class="radio mt-2">
                 <input type="radio" ([ngModel])="vehicleTerm" (click)="selectVehicleTerm('1')" [checked]="vehicleTerm=='1'" value="1" name="vehicle-term"/> Temporary
              </div>
              </div>
              <div class="pull-left ml-5">
              <div class="icon-left pl-4" style="height:auto">
                <img src="assets/Longtermpermit.png" style="height:118px;width:118px;">
              </div>
              <div class="radio mt-2">
                 <input type="radio" ([ngModel])="vehicleTerm" (click)="selectVehicleTerm('2')" [checked]="vehicleTerm=='2'" value="2" name="vehicle-term"/> Long-term Permit
              </div>
            </div>
           </div>

           <br style="clear:both;">
           <hr>
          </div>
          <div class="col-sm-6">
             <div class="row form-group mt-2">
              <div class="col-sm-3 pr-0">
                <label ><strong>Select Permit Type: </strong></label>
             </div>
             <div class="col-sm-8">
              <select class="form-control  permit-select" id="idCtype" [(ngModel)]="selectedPermit" (change)="onChange()">
                <option *ngIf="defaultValue == null" [value]="null">Select Permit Type</option>
                <option *ngIf="defaultValue  != null" >{{defaultValue}}</option>
                <ng-container *ngFor="let cat of permittype">
                  <option  *ngIf="(cat.freight_passenger_ind==vehicleType && cat.temp_long_ind == vehicleTerm)" [ngValue]="cat">{{cat.description}}</option>
                </ng-container>
              </select>
              </div>


           </div>
           <br>
           <div class="row form-group">
            <div class="col-sm-3">
              <label ><strong>My Reference : </strong></label>
           </div>
            <div class="col-sm-8">
              <input type="text"  #reference  [value]="referenceNum" ([ngModel])="referenceNum"  (keyup)="myRef(reference.value)" class="reference-input">
           </div>
         </div>
        </div>
        <!-- <div class="col-sm-6">
          <div class="col-md-12"><h1><span style="font-size:20px">How to apply for a permit</span></h1>

            <ol>
              <li>Select the application type in the list on the left (see below for details).</li>
              <li>Provide a reference or purchase order numberfor your use.</li>
              <li>Click the start buttom on bottom right of screen.</li>
              <li>From then on you can switch from tab to tab as you wish.</li>
              <li>When you have completed the application, press the submit button.</li>
            </ol>
            </div>

      </div> -->

      </div>
 </div>




<!-- <button
class="btn btn-md m-clr pull-right hd-btn"
(click)="cancelApplication()" title="Cancel"  style="float: right !important;">
<i class="fa fa-times"></i> Cancel</button>
<button
class="btn btn-md m-clr pull-right hd-btn mr-2"
(click)="saveApplication()" title="Save & Continueto step 2" style="float: right !important;">
<i class="fa fa-save"></i> Save & Continue</button> -->



